var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file form组件
 * @author (zhaojun10)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash-es';
import classnames from 'classnames';

import Input from '../Input';
import Select from '../Select';
import MultiSelect from '../MultiSelect';
import CheckboxGroup from '../Checkbox';
import RadioGroup from '../Radio';
import Radio from '../Radio/Radio';
import Button from '../Button';
import Textarea from '../Textarea';
import Cascader from '../Cascader';
import TimePicker from '../TimePicker';
import DatePicker from '../DatePicker';
import RadioButtonGroup from '../RadioButton/RadioButtonGroup';
import InputNumber from '../InputNumber';
import Transfer from '../Transfer';
import TreeSelect from '../TreeSelect';
import RangeDatePicker from '../DatePicker/RangeDatePicker';
import { noop, EleResize, classPrefix } from '../../common/util';

import './Form.less';
/* global getComputedStyle */
/**
 * 参数说明
 * submit           可选，提交表单，获取数据结果，参数1：验证结果<bool>；参数2：数据结果
 * className        可选，自定义类名
 */

var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.resizeHandler = function () {
            var width = getComputedStyle(_this.form).width;
            var lessThan640 = parseFloat(width) < 640;

            if (lessThan640 !== _this.state.lessThan640) {
                // 保证此state最先改变
                setTimeout(function () {
                    _this.setState({ lessThan640: lessThan640 });
                }, 0);
            }
        };

        _this.submit = function (s, e) {
            var submit = s || _this.props.submit;
            var flag = void 0;
            var state = _.cloneDeep(_this.state);
            delete state.lessThan640; // 删除非数据属性
            for (var name in state) {
                var data = state[name];
                var tmp = _this.tmp[name];
                if (data.value !== true) {
                    if (tmp.hidden || tmp.disabled || tmp.readOnly) {
                        data.validate = { ret: 0, message: '' };
                    } else {
                        data.validate = _this.toValidate(data.data, tmp.rule);
                    }
                }
            }

            _this.setState(_extends({}, state));

            for (var i in state) {
                if (!state[i] || !state[i].validate || state[i].validate.ret !== 0) {
                    flag = false;
                    submit(flag, state, e);
                    return;
                }
            }
            flag = true;
            submit(flag, state, e);
        };

        _this.onHandleChange = function (data, self, type, increment, isDelete) {
            var tmp = _this.tmp[increment];
            var state = _this.state[increment] ? _.cloneDeep(_this.state[increment]) : {};
            state.data = data;
            if (type === 0) {
                if (tmp.hidden || tmp.disabled || tmp.readOnly) {
                    state.validate = { ret: 0, message: '' };
                } else {
                    state.validate = _this.toValidate(data, tmp.rule);
                }
            }

            _this.setState(function (prevState) {
                if (isDelete) {
                    // 当组件移除时，同时移除state中对应值
                    delete prevState[increment];
                    return prevState;
                } else {
                    return _extends({}, prevState, _defineProperty({}, increment, state));
                }
            });
        };

        _this.renderItem = function () {
            var children = _this.props.children;
            return React.Children.map(children, function (child) {
                if (!child || !child.props) {
                    return;
                }
                return _this.getFormItemComponent(child);
            });
        };

        _this.state = {
            lessThan640: false
        };
        _this.tmp = {};

        _this.updateChildren(props);
        _this.toItem(_this.children);
        return _this;
    }

    _createClass(Form, [{
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(newProps) {
            if (!_.isEqual(this.props.children, newProps.children)) {
                this.updateChildren(newProps);
                this.toItem(this.children);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.responsive) {
                return;
            }
            this.resizeHandler();
            EleResize.on(this.form, this.resizeHandler);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (!this.props.responsive) {
                return;
            }
            EleResize.off(this.form, this.resizeHandler);
        }
    }, {
        key: 'getUpdateChildren',
        value: function getUpdateChildren(children) {
            var arr = [];

            if (_.isArray(children)) {
                for (var i = 0; i < children.length; i++) {
                    arr.push(this.getUpdateChildren(children[i]));
                }
            } else if (_.isObject(children)) {
                arr.push(children);

                var childrenOfChildren = children.props && children.props.children;
                if (childrenOfChildren) {
                    arr.push(this.getUpdateChildren(childrenOfChildren));
                }
            }
            return arr;
        }
    }, {
        key: 'updateChildren',
        value: function updateChildren(props) {
            var children = this.getUpdateChildren(props.children);
            if (_.isArray(children)) {
                this.children = _.flattenDeep(children);
            } else {
                this.children = children;
            }
        }
    }, {
        key: 'toItem',
        value: function toItem() {
            var _this2 = this;

            var childrens = this.children;
            if (_.isArray(childrens)) {
                childrens.forEach(function (child) {
                    if (!child || !child.props) {
                        return;
                    }
                    if (child.props.children) {
                        // 当FormItem被包裹时
                        if (_.isArray(child.props.children)) {
                            child.props.children.forEach(function (item) {
                                if (!item || !item.props) {
                                    return;
                                }
                                _this2.parseItem(item.props);
                            });
                        } else if (child.props.children.props) {
                            _this2.parseItem(child.props.children.props);
                        }
                    } else {
                        _this2.parseItem(child.props);
                    }
                });
            } else if (_.isObject(childrens)) {
                // 只有一个FormItem的情况 childrens类型为Obejct
                this.parseItem(childrens.props);
            } else {
                return null;
            }
        }
    }, {
        key: 'parseItem',
        value: function parseItem(props) {
            var type = props.type,
                rules = props.rules,
                readOnly = props.readOnly,
                disabled = props.disabled,
                name = props.name,
                hidden = props.hidden,
                validate = props.validate,
                value = props.value;


            if (readOnly || disabled || hidden) {
                var state = this.state[name];
                if (state && state.validate) {
                    state.validate = null;
                    this.setState(_defineProperty({}, name, state));
                }
            }
            if (!type) {
                return;
            }
            switch (type && type.toLowerCase()) {
                case 'input':
                case 'select':
                case 'radio':
                case 'checkboxgroup':
                case 'button':
                case 'textarea':
                case 'cascader':
                case 'radiobuttongroup':
                case 'multiselect':
                case 'timepicker':
                case 'datepicker':
                case 'inputnumber':
                case 'transfer':
                case 'treeselect':
                case 'rangedatepicker':
                    this.tmp[name] = {
                        type: type,
                        readOnly: readOnly,
                        disabled: disabled,
                        name: name,
                        hidden: hidden,
                        validate: validate,
                        value: value,
                        rule: rules
                    };
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'toValidate',
        value: function toValidate(data, selfRule) {
            var name = data.name,
                value = data.value;

            var rules = selfRule && selfRule.length > 0 ? selfRule : [];
            if (!_.isArray(rules)) {
                return { ret: -1, message: '验证需要传数组！' };
            }
            for (var i = 0; i < rules.length; i++) {
                var validate = rules[i].validate;
                if (!_.isFunction(validate)) {
                    return { ret: -1, message: '验证规则需要一个函数！' };
                }
                if (validate(value, name)) {
                    return { ret: -1, message: rules[i].message };
                }
            }
            return { ret: 0, message: '' };
        }
    }, {
        key: 'getFormItemComponent',
        value: function getFormItemComponent(child) {
            var _this3 = this;

            var _child$props = child.props,
                type = _child$props.type,
                submit = _child$props.submit,
                name = _child$props.name,
                onClick = _child$props.onClick,
                hidden = _child$props.hidden,
                submitFlag = _child$props.submitFlag,
                optionData = _child$props.optionData,
                value = _child$props.value,
                children = _child$props.children;


            var lessThan640 = this.state.lessThan640;

            var childProps = child.props;

            if (hidden === true) {
                return '';
            }
            var Tag = child.type;

            if (this.props.responsive) {
                childProps = _extends({}, childProps, {
                    responsive: this.props.responsive
                });
            }

            switch (type && type.toLowerCase()) {
                case 'input':
                    return React.createElement(Input, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        formFlag: true,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        key: name,
                        lessThan640: lessThan640
                    }));
                case 'select':
                    return React.createElement(Select, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        formFlag: true,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        key: name
                    }));
                case 'multiselect':
                    return React.createElement(MultiSelect, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        formFlag: true,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        key: name
                    }));
                case 'timepicker':
                    return React.createElement(TimePicker, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        formFlag: true,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        key: name
                    }));
                case 'datepicker':
                    return React.createElement(DatePicker, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        formFlag: true,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        key: name
                    }));
                case 'radio':
                    return React.createElement(
                        RadioGroup,
                        _extends({}, childProps, {
                            increment: name,
                            formFlag: true,
                            key: name,
                            inForm: true,
                            validate: this.state[name] ? this.state[name].validate : null,
                            onHandleChange: this.onHandleChange
                        }),
                        optionData.map(function (value) {
                            return React.createElement(
                                Radio,
                                { key: 'form-radio-' + value.name, value: value.name, disabled: value.disabled },
                                value.value
                            );
                        })
                    );
                case 'checkboxgroup':
                    return React.createElement(CheckboxGroup, _extends({}, childProps, {
                        formFlag: true,
                        key: name,
                        options: optionData,
                        defaultValue: value,
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        lessThan640: lessThan640
                    }));
                case 'button':
                    return React.createElement(Button, _extends({}, childProps, {
                        key: name,
                        onClick: submitFlag ? this.submit.bind(this, this.props.submit || submit) : onClick ? onClick : noop
                    }));
                case 'textarea':
                    return React.createElement(Textarea, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'cascader':
                    return React.createElement(Cascader, _extends({}, childProps, {
                        ref: 'form-' + name,
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'radiobuttongroup':
                    return React.createElement(RadioButtonGroup, _extends({}, childProps, {
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'inputnumber':
                    return React.createElement(InputNumber, _extends({}, childProps, {
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'transfer':
                    return React.createElement(Transfer, _extends({}, childProps, {
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'treeselect':
                    return React.createElement(TreeSelect, _extends({}, childProps, {
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                case 'rangedatepicker':
                    return React.createElement(RangeDatePicker, _extends({}, childProps, {
                        increment: name,
                        validate: this.state[name] ? this.state[name].validate : null,
                        onHandleChange: this.onHandleChange,
                        formFlag: true,
                        key: name
                    }));
                default:
                    if (children) {
                        // 子元素分为三类：数组，对象，其他(字符串，数字)
                        if (_.isArray(children)) {
                            return React.createElement(
                                Tag,
                                childProps,
                                React.Children.map(children, function (item) {
                                    if (!item || !item.props) {
                                        return;
                                    }
                                    return _this3.getFormItemComponent(item);
                                })
                            );
                        } else if (_.isPlainObject(children)) {
                            return React.createElement(
                                Tag,
                                childProps,
                                this.getFormItemComponent(children)
                            );
                        }
                        return React.createElement(
                            Tag,
                            childProps,
                            children
                        );
                    }
                    return [child];
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this4 = this;

            var _props = this.props,
                className = _props.className,
                responsive = _props.responsive;


            var rootCls = classnames((_classnames = {}, _defineProperty(_classnames, classPrefix + '-form', true), _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, 'less-than-640', this.state.lessThan640), _defineProperty(_classnames, 'responsive', responsive), _classnames));

            var wrapperCls = classnames((_classnames2 = {}, _defineProperty(_classnames2, classPrefix + '-form-wrapper', true), _defineProperty(_classnames2, 'responsive', responsive), _classnames2));

            return React.createElement(
                'div',
                { className: wrapperCls },
                React.createElement(
                    'form',
                    {
                        className: rootCls,
                        ref: function ref(el) {
                            _this4.form = el;
                        }
                    },
                    this.renderItem()
                )
            );
        }
    }]);

    return Form;
}(Component);

export default Form;


Form.propTypes = {
    className: PropTypes.string,
    submit: PropTypes.func,
    responsive: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    classPrefix: PropTypes.string
};

Form.defaultProps = {
    classPrefix: classPrefix
};